/* NVWA — "Starting soonest" sort.
   Client-side by design (decision D1): Shopify has no native sort by a variant
   metafield, and doing it server-side would mean either a second collection or
   giving up the native ?filter.p.m.* URLs that carry the SEO. So the grid is
   reordered in place using the data-next-start attribute that
   snippets/nvwa-course-date.liquid already emits on every card — the same value
   the visible row shows, so the order and the dates can never disagree.

   Scope note: this sorts the CURRENT PAGE. /collections/courses fits in one
   page, so it is a complete sort there. On a paginated collection it reorders
   only what is rendered.

   4 Sep 2026 -- OPT-IN ONLY. It is not the default, and that is deliberate.

   It was briefly made the default the same day, because the pre-publish sweep
   found a date-driven grid loading in the collection's own order with the sort
   control reading "Most relevant". Christian reverted it, for the reason the
   sweep itself had flagged: sorting by soonest start pushes all eighteen
   ON-DEMAND courses to the bottom of the page. Those are the cheapest entry
   points, they are always purchasable, and they are what a first-time visitor
   should be able to see without scrolling. Burying the easiest yes to protect
   a date ordering is the wrong trade on a catalog whose job is to get
   beginners started.

   So the page loads in the merchandised order, and "Starting soonest" sits at
   the top of the sort control for the shopper who wants it -- which is the
   shopper who already knows they need a date.

   Making it a default again is a small change and a real decision. It would
   have to be gated on three things, all of which have to hold: #NvwaToolbar
   present (rendered only where custom.show_toolbar is set, so ~40 other
   collections that share this section are not silently re-ordered); no
   sort_by in the URL (a shopper's own choice outranks a default); and no
   .pagination on the page (this sorts what is RENDERED, so on a paginated
   collection it would claim the soonest course starts in October while the
   real soonest sat on page four). */
(function () {
  'use strict';

  var PARAM = 'nvwa_sort';
  var VALUE = 'soonest';
  var OPT = 'nvwa-soonest';
  var LABEL = 'Starting soonest';
  var STRIP_AFTER = 3;   // keep the member strip after the Nth card

  function paramOn() {
    return new URLSearchParams(window.location.search).get(PARAM) === VALUE;
  }

  // Survives the theme's ajax filter re-render, which rewrites the URL from the
  // filter form alone and would otherwise drop our param.
  var isOn = paramOn();

  function setParam(on) {
    var u = new URL(window.location.href);
    if (on) { u.searchParams.set(PARAM, VALUE); } else { u.searchParams.delete(PARAM); }
    window.history.replaceState({}, '', u.toString());
  }

  function getGrid() {
    return document.querySelector('.product-grid.collection-grid') ||
           document.querySelector('.product-grid');
  }

  function getCards(grid) {
    return Array.prototype.filter.call(grid.children, function (el) {
      return el.classList && el.classList.contains('grid-item');
    });
  }

  function keyFor(card) {
    var row = card.querySelector('[data-next-start]');
    var v = row && row.getAttribute('data-next-start');
    return v && /^\d{4}-\d{2}-\d{2}$/.test(v) ? v : '';
  }

  function apply() {
    var grid = getGrid();
    if (!grid) { return; }
    var cards = getCards(grid);
    if (cards.length < 2) { return; }

    var rows = cards.map(function (el, i) { return { el: el, k: keyFor(el), i: i }; });
    rows.sort(function (a, b) {
      if (a.k && b.k) { return a.k < b.k ? -1 : (a.k > b.k ? 1 : a.i - b.i); }
      if (a.k) { return -1; }          // dated ahead of undated
      if (b.k) { return 1; }
      return a.i - b.i;                // undated keep their merchandised order
    });

    var frag = document.createDocumentFragment();
    rows.forEach(function (r) { frag.appendChild(r.el); });
    grid.appendChild(frag);

    // Re-seat any non-card band (the Premier Crew member strip). Appending the
    // cards above moves them past it, which would otherwise leave the strip
    // stranded as the first thing in the grid.
    Array.prototype.forEach.call(grid.querySelectorAll(':scope > :not(.grid-item)'), function (band) {
      var anchor = rows[STRIP_AFTER] && rows[STRIP_AFTER].el;
      if (anchor) {
        grid.insertBefore(band, anchor);
      } else {
        grid.appendChild(band);
      }
    });

    grid.setAttribute('data-nvwa-sorted', VALUE);
  }

  function injectOption() {
    // desktop: the native <select>
    Array.prototype.forEach.call(document.querySelectorAll('#SortBy'), function (sel) {
      if (!sel.querySelector('option[value="' + OPT + '"]')) {
        var o = document.createElement('option');
        o.value = OPT;
        o.textContent = LABEL;
        sel.insertBefore(o, sel.firstChild);
      }
      if (isOn) { sel.value = OPT; }
    });

    // mobile: the sidebar sort list, rendered as .filter-sort buttons
    Array.prototype.forEach.call(
      document.querySelectorAll('.collection-sidebar__group--sort .tag-list'),
      function (ul) {
        if (ul.querySelector('[data-value="' + OPT + '"]')) { return; }
        var li = document.createElement('li');
        li.className = 'tag' + (isOn ? ' tag--active' : '');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'filter-sort';
        b.setAttribute('data-value', OPT);
        b.textContent = LABEL;
        li.appendChild(b);
        ul.insertBefore(li, ul.firstChild);
      }
    );
  }

  // Capture phase, so this runs before the theme's own handlers and can stop
  // them navigating away for our pseudo-value.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.id !== 'SortBy') { return; }
    if (t.value === OPT) {
      e.stopPropagation();
      e.preventDefault();
      isOn = true;
      setParam(true);
      apply();
    } else if (isOn) {
      /* The shopper picked a native sort. Drop our param before the theme
         reads location.search. */
      isOn = false;
      setParam(false);
    }
  }, true);

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.filter-sort') : null;
    if (!b) { return; }
    if (b.getAttribute('data-value') === OPT) {
      e.stopPropagation();
      e.preventDefault();
      isOn = true;
      setParam(true);
      injectOption();
      apply();
    } else if (isOn) {
      isOn = false;
      setParam(false);
    }
  }, true);

  /* Runs on first load and again on every collection:reloaded, because the
     theme's ajax filter re-render replaces the grid and rebuilds the sort
     control from the server's markup. So the injected option and the ordering
     both have to be re-applied, and the param has to be written back onto a
     URL that the filter form just rewrote without it. */
  function boot() {
    if (isOn) { setParam(true); }
    injectOption();
    if (isOn) { apply(); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('collection:reloaded', boot);
})();
